import { ColumnSortEvent } from "src/app/components/dynamic-data-list/services/column-sort.service";

const collator = new Intl.Collator(undefined, {
    numeric: true,
    sensitivity: "base",
});

function sortData(a, b) {
    if (a < b) {
        return -1;
    } else if (a > b) {
        return 1;
    } else {
        return 0;
    }
}

export function sortByColumn(sortEvent: ColumnSortEvent) {
    let sortOrder = sortEvent.sortDirection === 'desc' ? -1 : 1;

    return (a, b) => {
        if (sortEvent.dataType === "date") {
            return sortData(new Date(a[sortEvent.sortColumn]), new Date(b[sortEvent.sortColumn])) * sortOrder;
        } else {
            return collator.compare(a[sortEvent.sortColumn], b[sortEvent.sortColumn]) * sortOrder;
        }
    }
}

export function groupBy<T>(list: T[], keyGetter: (item: T) => string): Map<string, T[]> {
    const map = new Map<string, T[]>();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        !!collection ? collection.push(item) : map.set(key, [item]);
    });
    return map;
}